import useMediaQuery from "hooks/useMediaQuery"
import { createContext, useContext, useState } from "react"

const SidebarContext = createContext()

export const SidebarProvider = ({ children }) => {
	const [collapsed, setCollapsed] = useState(false)
	const [toggled, setToggled] = useState(false)
	const [activeHeader, setActiveHeader] = useState("")
	const [addNewFormPath, setAddNewFormPath] = useState("")
	const [pnrRefreshToggle, setPnrRefreshToggle] = useState(false)

	const openMobileSidebar = () => setToggled(true)
	const closeMobileSidebar = () => setToggled(false)

	const toggleCollapse = () => setCollapsed((prev) => !prev)

	const isSmallScreen = useMediaQuery("(max-width: 767px)")

	return (
		<SidebarContext.Provider
			value={{
				collapsed,
				toggled,
				setCollapsed,
				setToggled,
				openMobileSidebar,
				closeMobileSidebar,
				toggleCollapse,
				activeHeader,
				setActiveHeader,
				addNewFormPath,
				setAddNewFormPath,
				isSmallScreen,
				pnrRefreshToggle,
				setPnrRefreshToggle,
			}}
		>
			{children}
		</SidebarContext.Provider>
	)
}

export const useSidebar = () => useContext(SidebarContext)
